import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { JobFair } from 'app/types';
import { useAppContext } from 'app/context/app-context';
import { JobfairService } from 'app/services/JobfairService';
import { useAuth } from 'app/context/auth-context';
import Select from 'react-select'
import { useParams } from 'react-router-dom';

const JobFairSelector: React.FC = () => {
    const { jobFair, setJobFair } = useAppContext();
    const [jobFairs, setJobFairs] = useState<JobFair[]>([]);
    const jobfairService = new JobfairService();
    const { user } = useAuth();
    const params = useParams<{ orgId: string, jobFairId: string }>();


    useEffect(() => {
        const fetchJobFairs = async () => {
            if (!user?.organizationId) return;
            const fetchedJobFairs = await jobfairService.getJobFairs(user?.organizationId);
            setJobFairs(fetchedJobFairs);
        };
        fetchJobFairs();
    }, []);

    useEffect(() => {
        if (!jobFair && jobFairs.length > 0) {
            const now = new Date();
            const nextJobFair = jobFairs
                .filter(jf => new Date(jf.startDate) > now)
                .sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime())[0];

            setJobFair(nextJobFair || jobFairs[0]);
        }
    }, [jobFairs]);

    return (
        <div className="d-flex align-items-center">
            <div className="btn btn-icon btn-active-light-primary position-relative w-30px h-30px w-md-40px h-md-40px me-3">
                <i className="ki-duotone ki-calendar fs-1">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>
            </div>
            {jobFairs.length > 0 ? (
                <div className='input-group input-group-solid flex-nowrap'>
                    <span className="input-group-text">
                    </span>
                    <div className='flex-grow-1'>
                        <Select
                            classNames={{
                                control: () => ('rounded-start-0'),
                            }}
                            className='react-select-styled react-select-solid'
                            classNamePrefix='react-select'
                            value={{ value: jobFair?.id, label: jobFair ? `${jobFair.name} (${moment(jobFair.startDate).format('DD MMM YYYY')})` : '' }}
                            onChange={(selected) => {
                                const selectedJobFair = jobFairs.find(jf => jf.id === selected?.value);
                                if (selectedJobFair) setJobFair(selectedJobFair);
                            }}
                            options={jobFairs.map((jobFair) => {
                                return { value: jobFair.id, label: `${jobFair.name} (${moment(jobFair.startDate).format('DD MMM YYYY')})` };
                            })}
                            placeholder='Select a job fair'
                        />
                    </div>
                    </div>
                    ) : (
                    <span className="badge badge-light-warning fs-7 fw-bold">No Job Fairs</span>
            )}
                </div>
            );
};

            export default JobFairSelector;
